const CustomizedLabelLeft = (props) => {
    return (
        <g x={props.viewBox.x} y={props.viewBox.y} transform="rotate(-90 100 100)">
            <foreignObject x={props.viewBox.x - 10} y={props.viewBox.y - 10} width={200} height={100}>
                <span style={{ color: 'mediumBlue' }}>Microsites</span>&nbsp;&amp;&nbsp;<span style={{ color: 'orange' }}>NKR</span>
            </foreignObject>
        </g>
    );
};

export default CustomizedLabelLeft;